
/*

CN
select '{tag: "'+CONVERT(nvarchar, Tag)+'",text: "'+CONVERT(nvarchar, Content) +'"},' from Base.Characters c left join Base.CharacterParents cp on c.ParentID = cp.ID where c.LanguageTag ='CN' 


EN
select '{tag: "'+CONVERT(nvarchar, Tag)+'",text: "'+CONVERT(nvarchar, Content) +'"},' from Base.Characters c left join Base.CharacterParents cp on c.ParentID = cp.ID where c.LanguageTag ='EN' 


 */

var language =  window.__$language

/*

 */

export function getString(Tag) {
    if (!Tag || Tag[0] != '$' && Tag[0] != '#') {
        return Tag;
    }
    var t = Tag;
    language.forEach(function (e) {

        if (e.tag == Tag) {
            t = e.text;
            return;
        }
    })
    return t;
}


export function StringFormat(str, arr) {
    if (arr) {
        var i = 0;
        var mstr = getString(str);
        arr.forEach(function (e) {
            mstr = mstr.replace("{" + i + "}", e);
            i++;
        })
        return mstr;
    } else {
        return str
    }
}

export default function (tag) {
    if (tag) {
        var re = /\{([\s\S]*?)\}/g
        var arr;
        var ls = [];
        var i = 0;
        var mstr = tag.substr(1);
        while ((arr = re.exec(tag)) != null) { //exec使arr返回匹配的第一个，while循环一次将使re在g作用寻找下一个匹配。 
            var tastr = arr[0];
            mstr = mstr.replace(arr[0], "{" + i + "}");
            ls.push(getString("$" + arr[1]));
            i++;
        }

        if(i==0){
            return getString(tag)
        }
        return StringFormat("$" + mstr, ls)
    }
    return tag
}










// WEBPACK FOOTER //
// ./src/model/language.js